(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["boebody-reels"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Only the reel nearest the middle of the rail plays. Everything else is paused, so a page with
    // six videos costs about the same as a page with one.
    function setup(root) {
      if (root.dataset.boeReelsBound === '1') return;
      root.dataset.boeReelsBound = '1';

      var rail = root.querySelector('[data-boe-reels-rail]');
      var reels = Array.prototype.slice.call(root.querySelectorAll('[data-boe-reel]'));
      if (!rail || !reels.length) return;

      var videos = reels.map(function (r) { return r.querySelector('video'); }).filter(Boolean);
      videos.forEach(function (v) { v.muted = true; v.loop = true; v.playsInline = true; });

      var navs = Array.prototype.slice.call(root.querySelectorAll('[data-boe-nav]'));

      // Which reel is nearest the middle right now. Used both to decide what plays and
      // to know where the arrows should take us next.
      function centreIndex() {
        var mid = rail.getBoundingClientRect().left + rail.clientWidth / 2;
        var bestIdx = 0;
        var bestGap = Infinity;
        reels.forEach(function (reel, i) {
          var box = reel.getBoundingClientRect();
          var gap = Math.abs(box.left + box.width / 2 - mid);
          if (gap < bestGap) { bestGap = gap; bestIdx = i; }
        });
        return bestIdx;
      }

      // Move one reel along. scrollIntoView is used on purpose instead of scrollLeft
      // arithmetic: the store is RTL, and scrollLeft's sign in a right-to-left container
      // differs between browsers. Asking the browser to centre an element sidesteps that
      // entirely and stays correct in both directions.
      function go(delta) {
        var target = Math.min(reels.length - 1, Math.max(0, centreIndex() + delta));
        reels[target].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }

      // The arrows double as a hint that there is more to the side, so the one at the end
      // fades out rather than disappearing and shifting the layout.
      function syncNav() {
        var i = centreIndex();
        navs.forEach(function (b) {
          var d = parseInt(b.getAttribute('data-boe-nav'), 10);
          b.disabled = (d < 0 && i === 0) || (d > 0 && i === reels.length - 1);
        });
      }

      navs.forEach(function (b) {
        b.addEventListener('click', function (event) {
          event.preventDefault();
          go(parseInt(b.getAttribute('data-boe-nav'), 10));
        });
      });
      if (reels.length < 2) navs.forEach(function (b) { b.hidden = true; });

      function activate() {
        var best = reels[centreIndex()];
        syncNav();

        reels.forEach(function (reel) {
          var video = reel.querySelector('video');
          if (!video) return;
          if (reel === best) {
            var playing = video.play();
            if (playing && playing.catch) playing.catch(function () {});
          } else {
            video.pause();
            video.muted = true;
            var toggle = reel.querySelector('[data-boe-sound]');
            if (toggle) toggle.setAttribute('aria-pressed', 'false');
          }
        });
      }

      var waiting = false;
      rail.addEventListener('scroll', function () {
        if (waiting) return;
        waiting = true;
        window.requestAnimationFrame(function () { waiting = false; activate(); });
      }, { passive: true });

      root.querySelectorAll('[data-boe-sound]').forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          var reel = button.closest('[data-boe-reel]');
          var video = reel && reel.querySelector('video');
          if (!video) return;
          video.muted = !video.muted;
          button.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
          if (!video.muted) {
            var playing = video.play();
            if (playing && playing.catch) playing.catch(function () {});
          }
        });
      });

      // pause everything while the section is off screen
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) { activate(); }
            else { videos.forEach(function (v) { v.pause(); }); }
          });
        }, { threshold: 0.15 }).observe(root);
      } else {
        activate();
      }
    }

    function boot() { document.querySelectorAll('[data-boe-reels]').forEach(setup); }
    boot();
    document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
